var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 46,
    viewBox: "0 0 91 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2279_5600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 0H0V45.92H91V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2279_5600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2279_5600",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91 0H0V45.6978H91V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2279_5600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5174 23.4525C41.5174 26.1285 39.5614 28.1004 37.1612 28.1004C34.7606 28.1004 32.8047 26.1285 32.8047 23.4525C32.8047 20.7577 34.7606 18.8047 37.1612 18.8047C39.5614 18.8047 41.5174 20.7577 41.5174 23.4525ZM39.6103 23.4525C39.6103 21.7804 38.4768 20.6362 37.1612 20.6362C35.8453 20.6362 34.7118 21.7804 34.7118 23.4525C34.7118 25.108 35.8453 26.2689 37.1612 26.2689C38.4768 26.2689 39.6103 25.1059 39.6103 23.4525Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9159 23.4525C50.9159 26.1285 48.9599 28.1004 46.5595 28.1004C44.1592 28.1004 42.2031 26.1285 42.2031 23.4525C42.2031 20.7598 44.1592 18.8047 46.5595 18.8047C48.9599 18.8047 50.9159 20.7577 50.9159 23.4525ZM49.0088 23.4525C49.0088 21.7804 47.8753 20.6362 46.5595 20.6362C45.2437 20.6362 44.1102 21.7804 44.1102 23.4525C44.1102 25.108 45.2437 26.2689 46.5595 26.2689C47.8753 26.2689 49.0088 25.1059 49.0088 23.4525Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9226 19.0855V27.4299C59.9226 30.8623 58.0313 32.2641 55.7953 32.2641C53.6906 32.2641 52.4239 30.7574 51.9461 29.5253L53.6064 28.7857C53.9021 29.5421 54.6265 30.4348 55.7934 30.4348C57.2246 30.4348 58.1116 29.4898 58.1116 27.7106V27.0421H58.045C57.6181 27.6058 56.7959 28.0984 55.7582 28.0984C53.5869 28.0984 51.5977 26.074 51.5977 23.4693C51.5977 20.8457 53.5869 18.8047 55.7582 18.8047C56.7939 18.8047 57.6162 19.2971 58.045 19.844H58.1116V19.0876H59.9226V19.0855ZM58.2467 23.4693C58.2467 21.8327 57.2266 20.6362 55.9286 20.6362C54.6127 20.6362 53.5105 21.8327 53.5105 23.4693C53.5105 25.0891 54.6127 26.2689 55.9286 26.2689C57.2266 26.2689 58.2467 25.0891 58.2467 23.4693Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9066 14.1953V27.8162H61.0469V14.1953H62.9066Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1587 24.9844L71.639 26.0405C71.1604 26.7969 70.0098 28.1004 68.0206 28.1004C65.5536 28.1004 63.7109 26.0594 63.7109 23.4525C63.7109 20.6886 65.5692 18.8047 67.8076 18.8047C70.0603 18.8047 71.1624 20.7241 71.5231 21.7615L71.7206 22.2895L65.9156 24.8629C66.36 25.7953 67.0508 26.271 68.0206 26.271C68.9912 26.271 69.6653 25.7596 70.1587 24.9844ZM65.6023 23.3121L69.4826 21.5875C69.2696 21.0071 68.6272 20.6026 67.8716 20.6026C66.9021 20.6026 65.5536 21.5183 65.6023 23.3121Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7647 22.2431V20.2712H31.9733C32.034 20.6149 32.0652 21.0214 32.0652 21.4614C32.0652 22.9409 31.6874 24.7703 30.4696 26.0737C29.285 27.3939 27.7716 28.098 25.7667 28.098C22.0506 28.098 18.9258 24.8583 18.9258 20.8811C18.9258 16.9037 22.0506 13.6641 25.7667 13.6641C27.8225 13.6641 29.287 14.5274 30.3873 15.6527L29.0873 17.0441C28.2982 16.252 27.2292 15.6359 25.7647 15.6359C23.0511 15.6359 20.9287 17.9766 20.9287 20.8811C20.9287 23.7854 23.0511 26.1261 25.7647 26.1261C27.5249 26.1261 28.5273 25.3696 29.1695 24.6823C29.6903 24.1249 30.033 23.3286 30.1681 22.241L25.7647 22.2431Z",
    fill: "#1F2022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.47ff4cf009afa055161702db771ba0f9.svg";
export { ForwardRef as ReactComponent };